import React, { useEffect } from 'react';
import Alert from '@xo-union/tk-component-alerts';
import { STANDARD_ERROR_MESSAGE } from '../../helpers/errorMessage';
import styles from './index.scss';

const ERROR_TIMEOUT = 4000;

interface Props {
  erroring: boolean;
  onTimeout: () => void;
}

interface AlertProps {
  type: string;
  content: string;
}

interface AlertRef {
  show: (props: AlertProps) => void;
  dismiss: () => void;
}

const CVAlert: React.FC<Props> = ({ erroring, onTimeout }) => {
  const alert = React.createRef<AlertRef>();
  useEffect(() => {
    if (erroring) {
      alert.current?.show({
        type: 'error',
        content: STANDARD_ERROR_MESSAGE,
      });
      const timeoutId = setTimeout(onTimeout, ERROR_TIMEOUT);
      return () => clearTimeout(timeoutId);
    } else {
      alert.current?.dismiss();
    }
  }, [erroring, alert, onTimeout]);

  return (
    <div className={styles.alert}>
      <Alert ref={alert} position="bottom" data-testid="cv-alert" />
    </div>
  );
};

export default CVAlert;
